//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: null
    },
    additionalAccessAdd: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: 'id',
        descending: true
      }
    }
  },
  computed: {
    request: function () {
      return this.record.request
    },
    successExternalSynchronization: function () {
      return !this.request.externalSynchronizationStatus || this.request.externalSynchronizationStatus.id === 'success'
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    columns: function () {
      return this.getColumns()
    }
  },
  methods: {
    getColumns: function () {
      const columns = [
        {
          name: 'toolName',
          label: 'Номенклатурная позиция',
          field: 'tool',
          format: value => value && value.name || 'Неизвестная позиция',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Единица измерения',
          labelTable: 'Единица измерения',
          defaultWidth: 70
        },
        {
          name: 'amountRecorded',
          label: 'Учтённое количество (по результату инвентаризации)',
          labelTable: 'Учтённое количество</br>(по результату инвентаризации)',
          defaultWidth: 100,
          sortable: true,
          hidden: this.request.externalSynchronizationErrorType && this.request.externalSynchronizationErrorType.id === 'correctionStockNegativeAmount'
        },
        {
          name: 'amountExternal',
          label: 'Учтённое количество (по 1C)',
          labelTable: 'Учтённое количество</br>(по 1C)',
          defaultWidth: 100,
          sortable: true,
          hidden: !(this.request.externalSynchronizationErrorType && this.request.externalSynchronizationErrorType.id === 'amountMismatch')
        },
        {
          name: 'correctionStockAmount',
          label: 'Количество на складе коррекции',
          labelTable: 'Количество на складе коррекции',
          defaultWidth: 100,
          sortable: true,
          hidden: this.request.externalSynchronizationErrorType && this.request.externalSynchronizationErrorType.id !== 'correctionStockNegativeAmount'
        }
      ]

      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }

      columns = columns.filter(column => {
        return !column.hidden
      })

      return [
        ...columns.filter(item => item.first === true),
        ...columns.filter(item => item.first !== true)
      ]
    },
    getTdStyle: function (col, row) {
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}

